<template>
  <div>
    <mortgage-page />
    <stacked-modal-root id="stacked-modal-root"></stacked-modal-root>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Segment from '@/Segment';
import StackedModalRoot from '@/modal/StackedModalRoot.vue';
import MortgagePage from '@/pages/responsive-pages/authenticated/navigation-pages/mortgages/MortgagePage.vue';

export default {
  name: 'OtsResults',
  components: {
    StackedModalRoot,
    MortgagePage,
  },
  props: {},
  async created() {
    if (this.otsFlowConfig && this.otsFlowConfig.resultsPageFlow) {
      this.componentName = this.otsFlowConfig.resultsPageFlow.flowId;
      Segment.trackUserGot('OTSConnectFlowEntered', { ots_type: this.otsFlowConfig.resultsPageFlow.flowId });
    } else {
      const { fid } = this.$route.query;
      if (fid) {
        await this.getFlowConfig(fid);
        if (this.otsFlowConfig && this.otsFlowConfig.resultsPageFlow) {
          this.componentName = this.otsFlowConfig.resultsPageFlow.flowId;
          Segment.trackUserGot('OTSConnectFlowEntered', { ots_type: this.otsFlowConfig.resultsPageFlow.flowId });
        }
      }
    }
  },
  data() {
    return {
      analyticsPrefix: '',
      componentName: null, // Will be set after loading flow config
    };
  },
  computed: {
    ...mapState('ots', ['otsFlowConfig', 'loading']),
  },

  methods: {
    ...mapActions('ots', ['getFlowConfig']),
  },
};
</script>

<style lang="scss" scoped>
.page {
  direction: ltr;
  height: 100%;
  > iframe {
    height: 100%;
    width: 100%;
    border: none;
  }
}
</style>
